import { RequestService } from '../RequestService'
import { useEnvStore } from 'store'

export class UniRequest extends RequestService {
  constructor() {
    super()
  }

  protected setBaseUrl(): string {
    const envStore = useEnvStore()
    return envStore.config?.apiuni || ''
  }
}

export const UniServices = new UniRequest()
